import { H3HexagonLayer } from "@deck.gl/geo-layers";

import type { ResolutionType, ViewportType } from "~/lib/map/types";
import { getH3IndexesFromViewport } from "./getH3IndexesFromViewport";

export const initHexagonSelectLayer = (
  viewport: ViewportType,
  resolution: ResolutionType,
  onHexagonClick: (h3Index: string) => void,
) => {
  // FIXME: Only one grid is displayed when [0, 180] and [0,-180] areas are mixed.
  // cf. https://github.com/uber/h3-py/issues/206
  const mapArea = getH3IndexesFromViewport(viewport, resolution);

  // https://deck.gl/docs/api-reference/geo-layers/h3-hexagon-layer
  return new H3HexagonLayer({
    id: "hexagon-select-layer",
    data: mapArea,
    pickable: true,
    wireframe: true,
    filled: true,
    extruded: true, // 3D
    elevationScale: 0,
    autoHighlight: true,
    getHexagon: (d) => d,
    getFillColor: () => [0, 0, 0, 1],
    getLineColor: () => [175, 175, 175, 255],
    getLineWidth: 1,
    lineWidthMinPixels: 1,
    onClick: (info) => {
      onHexagonClick(info.object);
    },
  });
};
